import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO, COMPANY_INFO } from '../utils/constants';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <h3>{COMPANY_INFO.name}</h3>
            <p>{COMPANY_INFO.description}</p>
            <div className="social-links">
              <a href={`tel:${CONTACT_INFO.phone}`} className="social-link">
                📞 Call Now
              </a>
              <a href={`mailto:${CONTACT_INFO.email}`} className="social-link">
                ✉️ Email
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Our Services</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/1-ton-truck">1 Ton Pickup Truck</Link></li>
              <li><Link to="/3-ton-truck">3 Ton Pickup Truck</Link></li>
              <li><Link to="/5-ton-truck">5 Ton Pickup Truck</Link></li>
              <li><Link to="/7-ton-truck">7 Ton Pickup Truck</Link></li>
              <li><Link to="/10-ton-truck">10 Ton Pickup Truck</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Information</h4>
            <div className="contact-details">
              <div className="contact-item">
                <span className="icon">📍</span>
                <span>{CONTACT_INFO.address}</span>
              </div>
              <div className="contact-item">
                <span className="icon">📱</span>
                <a href={`tel:${CONTACT_INFO.phone}`}>{CONTACT_INFO.phone}</a>
              </div>
              <div className="contact-item">
                <span className="icon">✉️</span>
                <a href={`mailto:${CONTACT_INFO.email}`}>{CONTACT_INFO.email}</a>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} {COMPANY_INFO.name}. All rights reserved.</p>
            <div className="legal-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
              <Link to="/disclaimer">Disclaimer</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
